export default __webpack_public_path__ + "assets/smart-vending-logo-black.png";